import Component from "@glimmer/component"

interface Args {
  title: string
}

export default class UnitMenuSecondaryTitle extends Component<Args> {}
